module.exports = __webpack_public_path__ + "img/Video.c083083.webp";